import React from "react";
import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";

import { APP_NAME, COMPANY_ADDRESS } from "../constants";
import logoBase from "../images/logo/logo.png";

function Footer({ footerLinks }) {
  return (
    <footer
      id="footer"
      className="position-relative bg-black align-content-start pb-5"
    >
      <div className="container">
        <div className="row py-5">
          <div className="col-md-4 col-xs-12 text-white">
            <Link
              to="/"
              className="d-flex align-items-center mb-3 link-dark text-decoration-none"
            >
              <img src={logoBase} className="headerLogo" alt="Logo" />
            </Link>
            <p>Expert training for exceptional dogs.</p>
            <p>{COMPANY_ADDRESS}</p>
            <p>&copy; {APP_NAME}</p>
          </div>
          {footerLinks.map((section, index) => (
            <div className="col-md-4 col-xs-12 mb-3" key={index}>
              <FooterLinks
                title={section.title}
                links={section.links}
                icons={section.icons}
              />
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}

function isInternalLink(href) {
  return /^\/(?!\/)/.test(href);
}

function FooterLinks({ title, links, icons }) {
  return (
    <div>
      <h4 className="text-custom-red fw-bold">{title}</h4>
      <ul className="nav flex-column">
        {links.map((link, index) => (
          <li className="nav-item mb-2" key={index}>
            {isInternalLink(link.href) ? (
              <Link className="nav-link p-0" to={link.href || "#"}>
                {icons && icons[index] ? (
                  <span className="me-1">{icons[index]}</span>
                ) : (
                  <span className="me-1">
                    <PawPrint />
                  </span>
                )}
                <span>{link.text}</span>
              </Link>
            ) : (
              <a className="nav-link p-0" href={link.href || "#"}>
                {icons && icons[index] ? (
                  <span className="me-1">{icons[index]}</span>
                ) : (
                  <span className="me-1">
                    <PawPrint />
                  </span>
                )}
                <span>{link.text}</span>
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Footer;
